import React from 'react';
import T from 'prop-types';
// assets
import mark from './pigpulse-mark.png';

// Winged pig with pulse line, recolored via CSS mask + currentColor. Aspect 560x201.
const ASPECT = 560 / 201;

const maskStyles = {
  WebkitMaskImage: `url(${mark})`,
  maskImage: `url(${mark})`,
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  maskPosition: 'center',
  WebkitMaskSize: 'contain',
  maskSize: 'contain',
};

const PigPulseIcon = ({ className, size, onClick }) => (
  <span
    className={className}
    title="PigPulse"
    onClick={onClick}
    style={{
      ...maskStyles,
      display: 'block',
      width: Math.round(size * ASPECT),
      height: size,
      backgroundColor: 'currentColor',
    }}
  />
);

PigPulseIcon.defaultProps = {
  className: '',
  size: 20,
  onClick: undefined,
};

PigPulseIcon.propTypes = {
  className: T.string,
  size: T.number,
  onClick: T.func,
};

export default PigPulseIcon;
